import React, {useMemo} from 'react';

import cs from 'classnames';
import moment from 'moment';
import {components} from 'react-select';

import {UserAvatar} from 'app/components/general/avatars';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

export const SelectUsersOption = (
  props: components.OptionProps
): JSX.Element => {
  const user = props.data;
  return (
    <components.Option {...props}>
      <div className="clearfix d-flex align-items-center flex-nowrap mr-2">
        <div>
          <UserAvatar user={user} />
        </div>
        <div className="ml-2 flex-grow-1 text-truncate">
          <div className="d-flex align-items-center">
            <div className="text-truncate">{user.name}</div>
            {user.is_guest_until != null ? (
              <GuestBadge is_guest_until={user.is_guest_until} />
            ) : null}
          </div>

          <div className="font-italic small text-truncate">{user.email}</div>
        </div>
      </div>
    </components.Option>
  );
};
type GuestBadgeProps = {
  is_guest_until: string;
};

function GuestBadge({is_guest_until}: GuestBadgeProps) {
  const isExpired = useMemo(() => moment().isAfter(is_guest_until), []);
  return (
    <LazyTooltip hide={!isExpired} tooltip={gt('Guest access expired')}>
      <div
        className={cs(
          'badge',
          'ml-1',
          isExpired ? 'badge-danger' : 'badge-primary'
        )}
      >
        <i className="fas fa-user-clock mr-1" />
        {gt('guest')}
      </div>
    </LazyTooltip>
  );
}
